import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit, OnDestroy {
  showBanner = false;
  showModal = false;
  dataAtual = new Date().toLocaleDateString('pt-BR');
  private destroy$ = new Subject<void>();

  constructor(
    private cookieConsentService: CookieConsentService
  ) {}

  ngOnInit(): void {
    this.cookieConsentService.consent$
      .pipe(takeUntil(this.destroy$))
      .subscribe(consent => {
        this.showBanner = this.cookieConsentService.shouldShowBanner();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  acceptCookies(): void {
    this.cookieConsentService.acceptCookies();
  }

  rejectCookies(): void {
    this.cookieConsentService.rejectCookies();
  }

  openPoliticaCookies(): void {
    console.log('=== ABRINDO MODAL SIMPLES ===');
    this.showModal = true;
    console.log('Modal simples aberto, showModal:', this.showModal);
  }

  closeModal(): void {
    console.log('=== FECHANDO MODAL SIMPLES ===');
    this.showModal = false;
  }
} 